import { useFormContext } from 'react-hook-form';
import { Icon, IconName } from '@optimus-web/core';

export const FormFieldHintIcon = ({ fieldName, isOptional }: { fieldName: string; isOptional?: boolean }) => {
    const { getFieldState, watch } = useFormContext();
    const inputValue = watch(fieldName);
    const { invalid } = getFieldState(fieldName) || {};

    const isSelectedValue = !invalid && inputValue;
    const isOptionalErrorColorVariant = isOptional ? 'info' : 'danger';

    return (
        <Icon
            size="small"
            value={isSelectedValue ? IconName.CheckCircle : IconName.AlertCircle}
            variant={isSelectedValue ? 'success' : isOptionalErrorColorVariant}
        />
    );
};
